<template>
    <div class="empresaDefineLunch" @click="openModal">
        <div class="form-control" disabled> {{ cantidad }}</div>
        <b-modal v-model="display">

            <div slot="modal-title">
                <strong>{{ asides.usuario.nombre }} {{ asides.usuario.apellidos }}</strong> <br>
            </div>

            <b-row class="mb-3">
                <b-col cols="7">
                    <b-card bg-variant="light" class="p-0 text-center" v-if="!isLoading">
                        <strong>{{ asides.sede.cede_titulo }}</strong>
                        <br>
                        <small>{{ asides.sede.codigo }} ({{ asides.sede.cede_tipo | uppercase }})</small>
                    </b-card>
                    <ui-spinner v-else></ui-spinner>
                </b-col>
                <b-col>
                    <b-card bg-variant="primary" class="p-0 text-center">
                        <strong>{{ day | uppercase }}</strong>
                        <br>
                        <small>{{ workingDate }}</small>
                    </b-card>
                </b-col>
            </b-row>


            <div slot="modal-footer">
                <b-row align-h="end">
                    <b-col cols="auto">
                        <b-input-group prepend="Total $">
                            <b-form-input :value="total" readonly />
                        </b-input-group>
                    </b-col>
                    <b-col cols="4">
                        <b-button-group>
                            <b-button variant="warning" @click="display = false"> Cancelar </b-button>
                            <b-button variant="primary" @click="tryToStore" :disabled="isProcessing">
                                <span v-if="isProcessing"><i class="fa fa-cog fa-spin"></i></span>
                                <span v-else>Aplicar</span>
                            </b-button>
                        </b-button-group>
                    </b-col>
                </b-row>

            </div>

            <template v-if="!isLoading">

                <b-card v-for="(planObj, $pOIndex) in asides.planes" :key="('pl-' + planObj.id)" :title="planObj.plan">

                    <ul>
                        <li v-for="recetaObj in filterPlanRecetas(planObj.plan_id)" :key="('plr-' + recetaObj.id_pk)">
                            {{ recetaObj.nombre }}
                        </li>
                    </ul>

                    <hr>

                    <b-row>
                        <b-col cols="5">
                            <b-input-group prepend="Cantidad:">
                                <b-form-input type="number" v-model="form[$pOIndex].cantidad" min="0" />
                            </b-input-group>
                        </b-col>
                        <b-col cols="7">
                            <b-input-group prepend="Precio $" :append="(form[$pOIndex].cantidad * form[$pOIndex].precio) | currency">
                                <b-form-input type="number" v-model="form[$pOIndex].precio" min="0" :readonly="form[$pOIndex].cantidad <= 0" />
                            </b-input-group>
                        </b-col>
                    </b-row>

                </b-card>

                <div class="debug" v-if="debug">
                    <h1>total</h1>
                    <pre>{{ total | currency }}</pre>
                    <pre>{{ form }}</pre>
                    <h1>day</h1>
                    <pre>{{ day }}: {{ workingDate }}</pre>
                    <h1>modoAgenda</h1>
                    <pre>{{ modoAgenda }}</pre>
                    <h1>presenciaId</h1>
                    <pre>{{ presenciaId }}</pre>
                    <h1>selectFilters</h1>
                    <pre>{{ selectFilters }}</pre>
                </div>

                <div class="debug" v-if="debug">
                    <h1>asides</h1>
                    <pre>{{ asides }}</pre>
                </div>

            </template>

        </b-modal>
    </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import { notify } from '@/utils.js'
import moment from 'moment'

const diasMatrix = {
    'Lunes': "1",
    'Martes': "2",
    'Miércoles': "3",
    'Jueves': "4",
    'Viernes': "5",
    'Sábado': "6",
    'Domingo': "7",
}

function buildAsides() {
    return {
        uPrescencia: {
            id: null,
            lunch_cedes_id: null,
            usuario_id_pk: null
        },
        usuario: {
            id_pk: null,
            nombre: null,
            apellidos: null
        },
        sede: {
            id: null,
            cede_titulo: 'Indefinido',
            cede_tipo: 'empresa'
        },
        planes: [],
        recetas: [],
        agendas: []
    }
}

export default {
    name: 'empresaDefineLunch',
    props: {
        debug: {
            type: Boolean,
            default: !true
        },
        day: {
            type: [String, Number],
            required: true
        },
        selectFilters: {
            type: [Array, Object],
            required: true
        },
        presenciaId: {
            type: [String, Number],
            required: true
        },
        modoAgenda: {
            type: String,
            default: 'Normal' // [Normal|Múltiple]
        },
        cantidad: {
            type: [String, Number],
            default: 0
        },
    },
    computed: {
        workingURI() {
            return 'easylunch/definepresenciayplanes/' + this.presenciaId + '/' + this.selectFilters.fechas.inicio + '/' + this.selectFilters.fechas.fin
        },
        total() {
            let total = 0;
            _.forEach(this.form, (compraObj) => {
                total += compraObj.cantidad * compraObj.precio;
            })
            return total
        },
        workingDate() {
            return moment(this.selectFilters.fechas.inicio).add((parseInt(diasMatrix[this.day]) - 1), 'day').format('YYYY-MM-DD')
        }
    },
    data: () => {
        return {
            isLoading: false,
            isProcessing: false,
            display: false,
            asides: buildAsides(),
            form: []
        }
    },
    methods: {
        async loadUp() {
            this.isLoading = true;
            try {
                const response = await axios.get(this.workingURI)
                if (!_.isObjectLike(response))
                    throw 'Error de conección';

                // ASIDES
                this.asides = (response.status) ? response.data : buildAsides();
                this.form = []

                _.forEach(this.asides.planes, planObj => {
                    let prevCompra = _.find(response.data.agendas, {fecha_pedido: this.workingDate, lunch_planes_id: planObj.id}),
                        cantidad = (prevCompra) ? prevCompra.cantidad	: 0,
                        precio = (prevCompra) ? (prevCompra.precio * 1) : (this.asides.sede[('precio_' + planObj.tipo)] * 1);

                    this.form.push({
                        id: planObj.id,
                        tipo: planObj.tipo,
                        cantidad,
                        precio
                    });
                })
            } catch (e) {
                notify(e)
            }
            this.isLoading = false;
        },
        async tryToStore() {
            this.isProcessing = true;
            try {
                const data2update = {
                    configs: this.form,
                    workingDate: this.workingDate
                }
                const response = await axios.put(this.workingURI, data2update);
                if (!_.isObjectLike(response))
                    throw 'Error grabando los datos';
                // mixedMSG(response.status, response.msg, response.class)
                if (response.status) {
                    this.display = false;
                    this.$emit('reload')
                }
            } catch (e) {
                notify(e)
            }
            this.isProcessing = false
        },
        filterPlanRecetas(planId) {
            return _.filter(this.asides.recetas, { id_plan_fk: planId, dia: diasMatrix[this.day] })
        },
        openModal() {
            this.display = true
            this.loadUp()
        }
    }
}
</script>

<style lang="less">
.empresaDefineLunch {}
</style>